import { Skeleton } from "antd";
import { useContext, useEffect, useState } from "react";
import Chart from "react-google-charts";
import { useQuery } from "react-query";
import { columnChartConfigurationOptions } from "../../config";
import { SettingContext } from "../../routes";
import HTTP from "../../services/httpService";
import { formatDate } from "../../services/util";

function Chart2() {
    const { selectedDates } = useContext(SettingContext);
    const [start_date, end_date] = selectedDates;
    const staff_id = localStorage.getItem("x-dashboard-staffid");
    const [ChartData, setChartData] = useState([]);
    const [formData, setFormData] = useState({
        staff_id,
        start_date: formatDate(start_date),
        end_date: formatDate(end_date),
    });

    const {
        status: chartStatus,
        data: chartRes,
        refetch: getChart,
    } = useQuery(
        "componet-wise-issue",
        async () => {
            return await HTTP("/analytics/getComponentsWiseIssues", {
                ...formData,
            });
        },
        { enabled: false },
    );

    useEffect(() => {
        getChart();
    }, []);

    useEffect(() => {
        const [start_date, end_date] = selectedDates;
        setFormData({
            ...formData,
            start_date: formatDate(start_date),
            end_date: formatDate(end_date),
        });
    }, [selectedDates]);

    useEffect(() => {
        if (chartStatus === "success") {
            setChartData(chartRes.data);
        }
    }, [chartStatus, chartRes]);

    return (
        <>
            {ChartData.length > 0 ? (
                <Chart
                    chartType="ColumnChart"
                    height={"90vh"}
                    width={"79vw"}
                    options={{
                        ...columnChartConfigurationOptions,
                        title: "Component Wise Issues",
                    }}
                    data={ChartData.map(([x, y]) => [
                        x,
                        y == "Counts" ? "Counts" : parseFloat(y),
                    ])}
                />
            ) : (
                <Skeleton
                    title={false}
                    active={true}
                    paragraph={{ rows: 10 }}
                />
            )}
        </>
    );
}

export default Chart2;
